






























































































import {Component, Prop, Vue} from "vue-property-decorator";
import {FormModel} from "ant-design-vue";
import ProvinceSelector from "@/modules/regions/ProvinceSelector/index.vue";
import DistrictSelector from "@/modules/regions/DistrictSelector/index.vue";
import WardSelector from "@/modules/regions/WardSelector/index.vue";
import MillisecondDatePicker from "@/shared/components/MillisecondDatePicker/index.vue";
import {PriceListStore} from "@/modules/pricelists/store";
import {assignValueToForm} from "@/shared/services/helper/utils";
import FreightServiceSelector from "@/shared/components/FreightServiceSelector/index.vue";
import EnumSelector from "@/shared/components/EnumSelector/index.vue";
import {CommonStatus} from "@/enums/status";
import UploadDocument from "@/shared/components/UploadDocument/Index.vue";
import ManageFee from "@/modules/pricelists/Form/components/ManageFee/index.vue";
import PostOfficeSelector from "@/shared/components/PostOfficeSelector/index.vue";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import AInputCustom from "@/shared/components/CustomInputAnt/index.vue";

@Component({
    name: "PriceListForm",
    components: {
        AInputCustom,
        PostOfficeSelector,
        ManageFee,
        UploadDocument,
        EnumSelector,
        FreightServiceSelector, MillisecondDatePicker, WardSelector, DistrictSelector, ProvinceSelector}
})
export default class extends mixins(CommonMixin) {
    @Prop()
    readonly id!: number;

    visibleManageFee = false;

    CommonStatus = CommonStatus;
    
    private form = {
        id: undefined,
        code: "",
        name: "",
        fuelRate: undefined,
        regionFarRate: undefined,
        status: undefined,
        filePath: undefined,
        postOfficeRowGuid: undefined
    };

    private rules = {
        code: [{ required: true, message: "Nhập mã bảng giá", trigger: "change" }],
        name: [{ required: true, message: "Nhập tên bảng giá", trigger: "change" }],
        fuelRate: [{ required: true, message: "Nhập phụ phí xăng dầu", trigger: "change" }],
        regionFarRate: [{ required: true, message: "Nhập phụ phí vùng xa", trigger: "change" }],
        filePath: [{ required: true, message: "Tải lên file excel", trigger: "change" }],
        postOfficeRowGuid: [{ required: false, message: "Chọn bưu cục", trigger: "change" }]
    };

    async created() {
        if (this.id) {
            this.rules.filePath = [];
            try {
                const data = await PriceListStore.singlePriceList(this.id);
                this.form = assignValueToForm(this.form, data);
                this.rules = { ...this.rules, filePath: [] }
            } catch (e) {
                this.$notification.error({
                    message: "Thất bại",
                    description: `${e.response?.data?.message || "Đã có lỗi xảy ra"}`
                })
            }
        }
    }

    private onSubmit() {
        (this.$refs.formPriceList as FormModel).validate(async valid => {
            if (!valid) return;
            try {
                this.id
                    ? await PriceListStore.updatePriceList(this.form)
                    : await PriceListStore.createPriceList(this.form);
                this.$message.success(`${this.id ? 'Sửa' : 'Tạo'} bảng giá thành công`);
                this.$router.push({ name: "listPriceLists" });
            } catch (e) {
                this.$message.error(`${e.response?.data?.message || `${this.id ? 'Sửa' : 'Tạo'} bảng giá thất bại`}`)
            }
        })
    }
}
